import { post, get, post_blob, put, post_OSS } from "@/axios";
/**
 * 国内发货-----------------------------------------------------------------------------------------
 * **/


//国内发货单 分页
export const domesticList = function (params) {
    return post('/wms/delivery/domestic/page', params)
}
//国内发货单 分页
export const unDeliveryAblepage = function (params) {
    return post('/wms/delivery/domestic/unDeliveryAblepage', params)
}
//打印拣货任务
export const printTask = function (params) {
    return get('/wms/delivery/domestic/print/pick', params)
}

//批量打印拣货任务 
export const bratchPrint = function (params) {
    return get('/wms/delivery/domestic/batch/print/pick', params)
}


//创建发货单
export const createDomestic = function (params) {
    return get('/wms/delivery/domestic/create', params)
}


//确认发货
export const updExpressNo = function (params) {
    return put('/wms/delivery/domestic/update/expressNo', params)
}

//批量保存物流单号
export const batchExpressNo = function (params) {
    return post('/wms/delivery/domestic/batch/update', params)
}





//调拨出库列表分页
export const transferList = function (params) {
    return post('/wms/delivery/domestic/transfer/page', params)
}

//调拨出库-发货列表分页
export const deliveryList = function (params) {
    return post('/wms/delivery/domestic/transfer/delivery/page', params)
}


//调拨出库-发货单添加批次包信息
export const getPkg = function (params) {
    return get('/wms/delivery/domestic/transfer/get/pkg', params)
}
//调拨出库-生成发货单
export const createDelivery = function (params) {
    return post('/wms/delivery/domestic/transfer/delivery', params)
}
//调拨出库-打印拣货
export const transferPrint = function (params) {
    return get('/wms/delivery/domestic/transfer/print', params)
}





//调拨单确认-根据快递单号查找批次包
export const getPkgByLogisticsNo = function (params) {
    return get('/wms/delivery/domestic/transfer/getPkgByLogisticsNo', params)
}
//调拨单确认-一键签收
export const batchSigh = function (params) {
    return post('/wms/delivery/domestic/transfer/confirm', params)
}




//导出

export const exportReturnItem = function (params) {
    return post_blob('/wms/delivery/domestic/exportReturnItem', params)
}
//导入退货件物流单号
export const importTrackingNumber = function (params) {
    return post_OSS('/wms/delivery/domestic/importTrackingNumber', params)
}


//退货地址修改

export const getModifyAddressFlag = function (params) {
    return post('/wms/delivery/domestic/getModifyAddressFlag', params)
}

/**
 * 相同收获信息的单据
 * @param {string} deliveryTaskCode 
 * @returns 
 */
export const queryRecipient = (deliveryTaskCode)=>post('/wms/delivery/domestic/queryRecipient',{deliveryTaskCode})